import { render, staticRenderFns } from "./person-auth-status.vue?vue&type=template&id=298c1d23&scoped=true&"
import script from "./person-auth-status.vue?vue&type=script&lang=js&"
export * from "./person-auth-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c1d23",
  null
  
)

export default component.exports